import { useQuery } from "@tanstack/react-query";
import adminApiClient from "../../api/admin";
import { ClockReminderSummaryEntry } from "../../Types";

const useClocksRemindersSummary = (enabled = true) => {
  return useQuery<ClockReminderSummaryEntry[]>({
    queryKey: ["clocksRemindersSummary"],
    queryFn: () => adminApiClient.getClocksRemindersSummary(),
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
    enabled,
  });
};

export default useClocksRemindersSummary;
